import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IThinkAnalyticsRepository } from '../../repositories/interfaces/IThinkAnalyticsRepository';
import { IThinkAnalyticsGetZone } from '../../../entity/interface/iThinkAnalytics';

export interface IGetZoneUseCase {
    execute(
        url: string,
        token: string,
        apiKey: string,
        profileName: string,
        userName: string
    ): Promise<IThinkAnalyticsGetZone>;
}

export class GetZoneUseCase implements IGetZoneUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getZoneRepository(): IThinkAnalyticsRepository {
        return container.resolve<IThinkAnalyticsRepository>(DI.REPOSITORIES.IThinkAnalyticsRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        url: string,
        token: string,
        apiKey: string,
        profileName: string,
        userName: string
    ): Promise<IThinkAnalyticsGetZone> {
        return this.getZoneRepository.getZone(url, token, apiKey, profileName, userName);
    }
}
